/* eslint-disable prettier/prettier */
/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import { useTheme } from '../../../providers/theme';
import { Col, Row, Card, Button, Image, Modal } from 'react-bootstrap';
import { toast } from 'react-hot-toast';

import {
  HeroSection,
} from '../components';
import {
  useSMMyProfilePage,
} from '../machines';
import { vappContainer, VApplication } from '../../../application';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { CredentialDetailPageService } from '../services';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { Loader } from '@/components';
const getSrv = () => {
  return vappContainer.get<CredentialDetailPageService>(
    CredentialDetailPageService.displayName
  );
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState({
    type: '',
    show: false,
  });
  const [initialData, setInitialData] = useState<any>({});
  const [parish, setParish] = useState('');
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [rejectmodal,setrejectModel] = useState(false);
  const [formDataConfig, setFormDataConfig] = useState(
    getSrv()?.agent.getStaticPageContentSync()
  );
  const [roeFormDataConfig, setRoeFormDataConfig] = useState(
    getSrv()?.agent.getStaticPageContentSync()
  );
  const storageSrv = StorageModule?.getInstance();
  const userProfile = storageSrv.get('myProfile', 'session');
  const role = userProfile?.org?.orgRole;
  const vuid = userProfile?.vuid;
  // const formDataConfig = getSrv()?.agent.getFormData();
  const [roe, setRoe] = useState(true);
  const [fontScale, setFontScale] = useState(
    storageSrv.get('fontScale', 'session') ?? 0
  );
  const updateFontScale = (font: any) => {
    setFontScale(font);
    storageSrv.set('fontScale', font, 'session');
  };
  useEffect(() => {
    if (role === 'BUSSINESS_ORG') setRoe(false);
  }, [role]);
  console.log('fff', role, userProfile);
  const [data, setData] = useState(null);
  // const { formDataMachine, formDataSend, formDataState } = useSMGetFormData({});
  // const { formCityMachine, formCitySend, formCityState } = useSMGetFormCity({});
  const srv = getSrv();
  const [isCreateProfileButton, setIsCreateProfileButton] = useState(true);
  const [whoAmI, setWhoAmI] = useState('');
  const [touched, setTouched] = useState(false);
  const [flag, setFlag] = useState(false);
  const [implicitsave, setImplicitsave] = useState(false);
  const theme = useTheme();
  const appSrv = getAppSrv();
  const [appno,setAppno] = useState('-');
  const { myProfilePageMachine, myProfilePageSend, myProfilePageState } =
    useSMMyProfilePage({});

  const onButtonPress = (key: string) => {
    // if (!showModal) {
    //   setShowModal(true);
    // }
    if (key === 'edit') {
      setShowModal({
        type: 'edit',
        show: true,
      });
    }
    if (key === 'docRejected') {
      setShowModal({
        type: 'docRejected',
        show: true,
      });
    }
  };

  console.log(
    'myProfilePageState?.event?.data?.value ::',
    myProfilePageState?.event?.data?.value
  );

  const onRefresh = () => {
    myProfilePageSend('TRIGGER_REFRESH', {});
  };

  useEffect(() => {
    if (myProfilePageState?.event?.data?.value && !data) {
      setData(myProfilePageState?.event?.data?.value?.intialData);
    }
  }, [myProfilePageState?.event?.data?.value]);
  console.log('lp->', data);

  const _renderPage = () => {
    if (myProfilePageState?.matches('GET_PAGE_CONTENT')) {
      return <Loader {...(formDataConfig?.loading?.loadingProfile || {})} />;
    }

    if (
      myProfilePageState?.matches('RENDER_PAGE') &&
      myProfilePageState?.event?.data?.value
    ) {
      console.log('find->orgprofile', myProfilePageState?.event?.data?.value);
      if (
        myProfilePageState?.event?.data?.value &&
        myProfilePageState?.event?.data?.value?.status !== 'ONBORADED'
      ) {
        console.log('onborad', myProfilePageState?.event?.data?.value);
        return (
          <>
            <HeroSection
              // {...data}
              {...(myProfilePageState?.event?.data?.value || {})}
              onHeroButtonClick={onButtonPress}
              showcomment={rejectmodal}
              setShowComment={setrejectModel}
            />
          </>
        );
      }
      return (
        <>
          <Loader {...(formDataConfig?.loading?.usersEmpty || {})} />
        </>
      );
    }
    return null;
  };
  const _renderErrorModals = () => {
    if (myProfilePageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(formDataConfig?.error?.getProfile || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  
    return null;
  };

  const onCreateProfile = () => {
    setShowForm(true);
  };

  return (
    <>
      {_renderPage()}
      {_renderErrorModals()}
    </>
  );
};
